import { DatalayersMap, isArrayEmpty } from "../../omnia"
import { Selection } from "../types"

/**
 *
 * @param fields All visible fields
 * @param map Map
 */
export function useViewMapExtent(fields: Selection["fields"], map: DatalayersMap) {

    const dependencyKey = React.useMemo(() => fields.map(f => f.fieldId).join(","), [fields])

    React.useEffect(() => {

        if (fields && map) {

            const fieldIds = fields.map(f => f.fieldId)

            const features = map.fieldsLayer.findFields(fieldIds)

            if (!isArrayEmpty(features)) {
                map.viewExtent({ items: features })
            }

        }

    }, [dependencyKey, map])

}
